import { render, staticRenderFns } from "./SimpleExamModelDelete.vue?vue&type=template&id=3bab45b0&"
import script from "./SimpleExamModelDelete.vue?vue&type=script&lang=js&"
export * from "./SimpleExamModelDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports